import React from "react";
import Modal from "src/components/ui/Modal";
import TenantRoleForm from "src/components/forms/TenantRoleForm";

interface AddEditRoleModalProps {
  open: boolean;
  onClose: () => void;
  tenantId?: string;
  existingRole?: any;
  isAdminAuth?: boolean;
}

const AddEditRoleModal: React.FC<AddEditRoleModalProps> = ({
  open,
  onClose,
  tenantId,
  existingRole,
  isAdminAuth = false,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={existingRole ? "Edit Role" : "Add New Role"}
      //   width="max-w-4xl"
      size="3xl"
    >
      <TenantRoleForm
        tenantId={tenantId}
        existingRole={existingRole}
        isAdminAuth={isAdminAuth}
        onCancel={onClose}
        onSuccess={onClose}
      />
    </Modal>
  );
};

export default AddEditRoleModal;
